module.exports = __webpack_public_path__ + "img/demo4-poster.be49330e.jpg";